import "swiper/css";
import "swiper/css/pagination";

import { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

const desktopCarousel = () => {
    const pagination = {
        clickable: true,
    };

    return (
        <div className="carouselMainbox">
            <Swiper
                dir="rtl"
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: true,
                }}
                loop={true}
                spaceBetween={30}
                pagination={pagination}
                modules={[Autoplay, Pagination]}
                className="mySwiper"
            >
                <SwiperSlide>
                    <img
                        src={require("../../assets/images/curousel/havayar.jpg")}
                        alt="..."
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        src={require("../../assets/images/curousel/havayar2N.jpg")}
                        alt="..."
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        src={require("../../assets/images/curousel/DRON.jpg")}
                        alt="..."
                    />
                </SwiperSlide>
            </Swiper>
        </div>
    );
};

export default desktopCarousel;


